import { message, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  deleteMemberAccount,
  getEnterpriseMemberList,
  sendInvitationToMembers,
  updateUserRole,
} from '../../api/constlink';
import InviteMemberModal from '../../components/enterprises/InviteMemberModal';
import MyEnterpriseUserListComponent from '../../components/enterprises/MyEnterpriseUserListComponent';
import UpdateUserRoleModal from '../../components/enterprises/UpdateUserRoleModal';
import { RootState } from '../../modules';
import { User } from '../../modules/auth';

interface MyEnterpriseUserListContainerProps {
  enterpriseId: string;
}
function MyEnterpriseUserListContainer({
  enterpriseId,
}: MyEnterpriseUserListContainerProps) {
  const [member, setMember] = useState<any>(null);
  const [visible, setVisible] = useState<boolean>(false);
  const [visible2, setVisible2] = useState<boolean>(false);
  const [employees, setEmployees] = useState<User[]>([]);

  const myEnterprise = useSelector(
    (state: RootState) => state.auth.myEnterprise.data,
  );

  const user = useSelector((state: RootState) => state.auth.auth.data);

  useEffect(() => {
    (async () => {
      setEmployees(
        await getEnterpriseMemberList({
          enterpriseId,
        }),
      );
    })();
  }, [enterpriseId]);

  const _updateUserRole = async (value: any) => {
    await updateUserRole({
      enterpriseId,
      userId: member.id,
      user: { roleName: value.roleName, isEnabled: value.isEnabled },
    });
    setEmployees(
      await getEnterpriseMemberList({
        enterpriseId,
      }),
    );
    setVisible(false);
  };

  const onCancel = () => setVisible(false);

  function openUpdateUserRoleModal(member: User) {
    setMember(member);
    setVisible(true);
  }

  const _sendInvitationToMembers = async (formData: any) => {
    setVisible2(false);
    if (myEnterprise === null) {
      Modal.error({
        content: '멤버에게 초대 메일 발송을 실패할 수 없습니다.',
      });
      return;
    }
    const { name, corporatePhone, address } = myEnterprise;

    try {
      await sendInvitationToMembers({
        enterpriseId,
        data: {
          enterprise: {
            name,
            corporatePhone,
            address,
          },
          ...formData,
        },
      });
      Modal.success({
        content: '멤버에게 초대 메일 발송을 성공 하였습니다.',
      });
    } catch (error: any) {
      Modal.error({ content: `${error.response.data.message}` });
    }
  };

  const openInviteMemberModal = () => {
    setVisible2(true);
  };

  const onCancel2 = () => setVisible2(false);

  const _deleteMemberAccount = async (memberId: number) => {
    await deleteMemberAccount({ enterpriseId, memberId });
    setEmployees(
      await getEnterpriseMemberList({
        enterpriseId,
      }),
    );
    message.success('멤버 계정이 삭제(퇴사) 되었습니다.');
  };

  return (
    <>
      {employees && user && (
        <MyEnterpriseUserListComponent
          data={employees}
          user={user}
          openUpdateUserRoleModal={openUpdateUserRoleModal}
          openInviteMemberModal={openInviteMemberModal}
          deleteMemberAccount={_deleteMemberAccount}
        />
      )}
      {member && visible && (
        <UpdateUserRoleModal
          visible={visible}
          member={member}
          updateUserRole={_updateUserRole}
          onCancel={onCancel}
        />
      )}
      <InviteMemberModal
        visible={visible2}
        sendInvitationToMembers={_sendInvitationToMembers}
        onCancel={onCancel2}
      />
    </>
  );
}

export default MyEnterpriseUserListContainer;
